import * as React from 'react';
import axios from 'axios';
import {IReactStep, default as steps} from './steps';
import { withJob } from 'react-jobs';
import { connect } from 'react-redux';
import HomePage from './scenes/HomePage';
import Prelaunch from './scenes/Prelaunch';
import { push } from 'react-router-redux';
import * as api from '../../data/api/api';
import { bindActionCreators } from 'redux';
import { IStore } from '../../redux/IStore';
import Tracking from './components/Tracking';
import { formValueSelector } from 'redux-form';
import * as Commonmark from 'react-commonmark';
import Loading from '../../components/Loading/index';
import { flow, isUndefined, each, set } from 'lodash';
import { IAuthState } from '../../services/auth/models';
import { actions as quoteActions } from '../../services/quote/reducer';
import RetrieveAggregatorQuote from './components/RetrieveAggregatorQuote';
import { actions as brandingActions } from '../../services/branding/reducer';
import { Route, RouteComponentProps, Switch, withRouter, Redirect } from 'react-router';
import {Button, Col, Modal as BootstrapModal, OverlayTrigger, Popover, Row} from 'react-bootstrap';
import { IQuoteActions, IQuoteState as IQuoteServiceState } from '../../services/quote/models';
import {
  IChannel,
  ICustomer,
  IIAS,
  IIOBSP,
  IPolicyApplication,
  IProduct,
  IStep,
  QuoteStatus,
} from '../../data/api/models';
import { IBrandingActions, IBrandingState, II18nMessages } from '../../services/branding/models';
import {Link} from 'react-router-dom';
import FaInfoCircle from 'react-icons/fa/info-circle';
import {getReferralsAndDeclines} from '../../util/helpers';
import {RCPStrengths} from '../../components/RCPStrengths';
import { Player } from 'video-react';

const ModalHeader = BootstrapModal.Header;
const ModalTitle = BootstrapModal.Title;
const ModalBody = BootstrapModal.Body;

interface IQuoteProps extends RouteComponentProps<any> {
  auth: IAuthState;
  i18n: II18nMessages;
  steps: IReactStep[];
  channel: IChannel;
  customer: ICustomer;
  branding: IBrandingState;
  quote: IQuoteServiceState;
  encryptCardCvv: string;
  encryptCardNumber: string;
  encryptExpiryYear: string;
  encryptExpiryMonth: string;
  actions: {
    quote: IQuoteActions;
    branding: IBrandingActions,
    push(route: string);
  };

  ias?: IIAS;
  iobsp?: IIOBSP;
}

interface IQuoteState {
  showModal: boolean;
  values: any;
}

class Quote extends React.Component<IQuoteProps, IQuoteState> {
  public state = {
    showModal: false,
    values: null,
    transactionId: null,
  };

  public componentWillMount() {
    const { actions } = this.props;
    actions.branding.getProduct();

    if (process.env.BROWSER) {
      window.addEventListener('message', this.handleWindowMessage);
    }

    // if (! quote.initialised) {
    //   actions.quote.initFromProduct(product, quote, branding);
    // }
  }

  private handleWindowMessage = (event: MessageEvent) => {
    const { actions, encryptCardNumber, encryptCardCvv, encryptExpiryMonth, encryptExpiryYear } = this.props;

    // For Chrome, the origin property is in the event.originalEvent object.
    const origin = event.origin || event.originalEvent.origin;

    if (origin !== axios.defaults.baseURL) {
      return;
    }

    const data = event.data;

    this.scrollToTop();

    if (data.id3d) {
      // received an id3d number back from Paybox, resend with card details
      api.completeTransaction(
        data.transaction_id,
        data.id3d,
        encryptCardNumber,
        encryptCardCvv,
        encryptExpiryMonth,
        encryptExpiryYear,
        data.auth_only,
      ).then((response) => {
        const data = response.meta;
        if (data.status !== 'complete' && data.status !== 'scheduled') {
          // Show an error?

          actions.quote.error('Card Payment was unsuccessful: ' + data.message);
          this.closeModal();

          return;
        }

        actions.quote.complete(data.policies[0]);
        this.closeModal();

        actions.quote.addStepToWizard('complete', false);

        actions.push('/complete');
      });

      return;
    }
  }

  public openModal = (values, transactionId) => {
    this.setState({
      showModal: true,
      transactionId,
      values,
    });
  }

  public closeModal = () => {
    this.setState({
      showModal: false,
      values: null,
    });
  }

  private getCurrentLocation = () => {
    const { steps } = this.props;

    return this.getCurrentLocationFromSteps(steps);
  }

  private getCurrentLocationFromSteps = (steps) => {
    const { location } = this.props;
    let currentLocationIndex = null;

    steps.forEach((step, key) => {
      if (step.route === location.pathname) {
        currentLocationIndex = key;
      }
    });

    return currentLocationIndex;
  }

  private scrollToTop = () => {
    if (process.env.BROWSER) {
      window.scrollTo(0, 0);
    }
  }

  private handleBack = () => {
    const { steps, actions } = this.props;

    const currentLocation = this.getCurrentLocation();

    actions.push(steps[ currentLocation - 1 ].route);
    this.scrollToTop();
  }

  private getNextStep = (formValues: IPolicyApplication): IReactStep => {
    const { steps } = this.props;
    const currentLocation = this.getCurrentLocation();

    let nextStep = steps [currentLocation + 1];
    for (let i = currentLocation + 1; i < steps.length; i++) {
      nextStep = steps[i];

      if (! nextStep.hasOwnProperty('enabled')) {
        break;
      }

      if (nextStep.enabled(formValues)) {
        break;
      }
    }

    return nextStep;
  }

  private handleCalculate = () => {
    const { actions } = this.props;

    return actions.quote.submitForm(null, true, true)
      .then((formValues: IPolicyApplication) => {
        actions.quote.calculate(formValues);
      });
  }

  private handleSubmit = (formValues: IPolicyApplication) => {
    const { steps, actions, encryptCardNumber, encryptCardCvv } = this.props;
    const currentLocation = this.getCurrentLocation();
    const currentStep = steps [ currentLocation ];
    const nextStep = this.getNextStep(formValues);
    const isFinalStep = nextStep.key === 'complete';

    if (! isFinalStep) {
      formValues.steps.push(nextStep.key);
      actions.quote.addStepToWizard(nextStep.key);
    }
    const handleNextStep = this.handleNextStep(formValues, nextStep);

    if (isUndefined(currentStep.key) || ! currentStep.saveApplication) {
      actions.quote.addStepToWizard(nextStep.key, false);
      handleNextStep();
      return;
    }

    if (nextStep.key === 'schemeChoice') {
      formValues.calculateAllSchemes = true;
    }

    if (isFinalStep) {
      set(formValues, 'card.cardNumber', encryptCardNumber);
      set(formValues, 'card.cvv', encryptCardCvv);
    }

    return actions.quote.submitForm(formValues, isFinalStep, false, currentStep.saveApplicationWithPatch)
      .then(handleNextStep);
  }

  private handleNextStep = (formValues, nextStep: IStep) => () => {
    const { actions } = this.props;

    if (nextStep.key === 'complete') {
      return actions.quote.purchase(formValues)
        .then((data) => {
          actions.quote.complete(data.policies[0]);
          actions.quote.addStepToWizard('complete', false);

          actions.push(nextStep.route);

          this.scrollToTop();
        })
        .catch((error) => {
          let rethrow = true;
          let message = null;

          each(error.response.data.errors, (e: any) => {
            if (e.id !== 'redirect-to-provider') {
              message = e.detail;
              return;
            }

            this.openModal(formValues, e.data.transactionId);
            rethrow = false;
          });

          if (! rethrow) {
            return;
          }

          if (message) {
            actions.quote.error(message);
            this.scrollToTop();
          }

          throw error;
        });
    }

    if (nextStep.calculatePremium) {
      actions.quote.calculate(formValues);
    }

    actions.push(nextStep.route);
    this.scrollToTop();

  }

  private renderStepRoutes = (product: IProduct) => {
    const { steps, quote, i18n, channel } = this.props;

    return steps.map((step, key) => {
      const { route: routePath } = step;
      const exact = routePath === '/';

      const onBack = key > 0 ? this.handleBack : null;

      return (
        <Route key={key} exact={exact} path={routePath}>
          <div className={'animated fadeIn' + ' ' + step.key}>
            <step.component
              i18n={i18n}
              onBack={onBack}
              product={product}
              renewal={quote.application.renewal}
              channel={channel}
              onSubmit={this.handleSubmit}
              handleCalculate={this.handleCalculate}
              initialValues={quote.application}
              renderDefinition={this.renderDefinition(product)}
              {...this.props}
            />
          </div>
        </Route>
      );
    });
  }

  private renderDefinition = (product: IProduct) => (name: string) => {
    const definition = product.metadata.definitions[name];

    if (! definition) {
      return null;
    }

    const popover = (
      <Popover
        id={`popover-${name}`}
      >
        <Commonmark
          source={definition}
          linkTarget={'_blank'}
        />
      </Popover>
    );

    return (
      <OverlayTrigger
        trigger="click"
        rootClose={true}
        placement="right"
        positionTop={50}
        overlay={popover}
        positionLeft={200}
      >
        <button className="info-btn" type="button">
          <FaInfoCircle className="" />
        </button>
      </OverlayTrigger>
    );
  }

  private renderPaymentModal = () => {
    return (
      <BootstrapModal
        show={true}
        bsSize="large"
        keyboard={false}
        backdrop="static"
        onHide={this.closeModal}
      >
        <ModalHeader closeButton={true}>
          <ModalTitle>Paiement</ModalTitle>
        </ModalHeader>
        <ModalBody>
          <iframe src={api.getPaymentUrl(this.state.transactionId)} className="payments-modal" />
        </ModalBody>
      </BootstrapModal>
    );
  }

  private renderBreadcrumbs = () => {
    const { steps, ias, iobsp, quote } = this.props;

    const stepsFiltered = steps.filter((step) => {
      if (! ias || ! iobsp) {
        return true;
      }
      return step.enabled({
        ias,
        iobsp,
      });
    });

    const referralsOrDeclines = getReferralsAndDeclines(quote);
    const currentLocation = this.getCurrentLocationFromSteps(stepsFiltered) || 0;
    let showLinks = stepsFiltered[currentLocation].key !== 'complete'
      && (referralsOrDeclines.empty || (! referralsOrDeclines.empty && ! stepsFiltered[currentLocation].showReferrals));

    const items = stepsFiltered.map((step, index) => {
      let itemClass = index <= currentLocation ? 'visible' : 'hidden';
      const isCurrentTab = index === currentLocation;
      if (isCurrentTab) {
        itemClass += ' active';
      }

      if (quote.application.status === QuoteStatus.REFERRAL_APPROVED) {
        showLinks = referralsOrDeclines.enableLinkOnTabs.includes(stepsFiltered[index].key);
      }

      return (
        <li key={index}>
          {showLinks ? (
            <Link
              className={itemClass}
              to={isCurrentTab ? '#' : step.route}
            >
              {step.title}
            </Link>
          ) : (
            <a href="javascript:void(0)" className={itemClass}>
              {step.title}
            </a>
          )}

        </li>
      );
    });

    return (
      <div className="breadcrumb-custom-container">
        <div className="container">
          <ul className="breadcrumb-custom">
            {items}
          </ul>
        </div>
      </div>
    );
  }

  private renderHomePageBg = () => {
    return (
      <div className="bg-container animated fadeIn home">
        <img src={require('./img/bg-dark.jpg')} alt=""/>
      </div>
    );
  }

  private handleGetQuote = () => {
    const { actions } = this.props;
    actions.quote.startQuoteProcess();
  }

  private renderHomePageSecondaryText = () => {
    return (
      <div className="container homepage-secondary">
        <Row>
          <Col md={12}>
            <h2>
              VOTRE ASSURANCE EN LIGNE A PARTIR DE 138 € HT PAR AN
            </h2>
          </Col>
        </Row>

        <RCPStrengths />

        <Row>
          <Col md={12}>
            <p>
              <strong>Votre chiffre d'affaires est supérieur à 750 000 € ou vous souhaitez des montants de garanties
                supérieurs aux minimum légaux ?</strong><br/>
              Contactez directement notre équipe au +33 (0)1 44 70 71 00 ou écrivez à <strong>
              <a className="red" href="mailto:rcpro.france@msamlin.com">rcpro.france@msamlin.com</a> </strong>
              pour demander un devis.
            </p>
          </Col>
        </Row>

        <Row>
          <Col mdOffset={2} md={8}>
            <Player
              autoPlay={true}
            >
              <source src="https://s3-eu-west-1.amazonaws.com/msamlin-uat2/files/msAmlin_OUT_180912_v01.mp4" />
            </Player>
          </Col>
        </Row>
      </div>
    );
  }

  public render() {
    const { actions, steps, quote } = this.props;
    const product = actions.branding.getProduct();
    const currentLocation = this.getCurrentLocation() || 0;

    if (quote.application.steps && quote.application.steps.indexOf(steps[currentLocation].key) === -1) {
      return (
        <Redirect to={steps[0].route} />
      );
    }

    return (
      <div className={'internal-page' + (this.props.branding.channel.live ? '' : ' prelaunch')}>
        <Tracking />
        <Route exact={true} path="/aggregator/:id" component={RetrieveAggregatorQuote} />
        {quote.startQuoteProcess && this.renderBreadcrumbs()}

        <div className="container">
          {(this.props.branding.channel.live && quote.startQuoteProcess) && (
            <Row>

              <Col md={12}>
                <div className="quote-content-container">
                  <Switch>
                    {this.renderStepRoutes(product)}
                  </Switch>
                </div>
              </Col>

              {/*<Col md={4} sm={12}>*/}
                {/*<Row>*/}
                  {/*{quoteReference !== '' && !quote.complete && (*/}
                    {/*<Col xs={12}>*/}
                      {/*<SaveQuoteModal quoteReference={quoteReference} {...this.props} />*/}
                    {/*</Col>*/}
                  {/*)}*/}
                  {/*<Col xs={12}>*/}
                    {/*<DocumentList isOnQuoteProcess={true}/>*/}
                  {/*</Col>*/}
                {/*</Row>*/}
              {/*</Col>*/}
            </Row>
          )}

          {(this.props.branding.channel.live && ! quote.startQuoteProcess) && (
            <Route exact={true} path="/" component={HomePage}/>
          )}

          {!this.props.branding.channel.live && (
            <Route component={Prelaunch}/>
          )}
        </div>

        {(this.props.branding.channel.live && !quote.startQuoteProcess) && (
          <div>
            <Route exact={true} path="/" component={this.renderHomePageBg}/>
            <Route exact={true} path="/" component={this.renderHomePageSecondaryText}/>
          </div>
        )}
        {this.state.showModal && this.renderPaymentModal()}
      </div>
    );
  }
}

let selector;

export default flow([
  withJob({
    work: (props: IQuoteProps) => {
      const promises = [];

      // if (props.quote.frenchCommerceChambers.length === 0) {
      //   promises.push(props.actions.quote.loadFrenchCommerceChambers());
      // }

      return Promise.all(promises);
    },
    LoadingComponent: (props) => <Loading/>,
    ErrorComponent: ({ error }) => {
      console.error(error);

      return (
        <div>
          {error.message}
        </div>
      );
    },
  }),
  (component) => {
    selector = formValueSelector('quote');

    return component;
  },
  connect(
    (state: IStore) => {
      const encryptCardCvv = selector(state, 'card.cvv');
      const encryptCardNumber = selector(state, 'card.cardNumber');
      const encryptExpiryYear = selector(state, 'card.expiryYear');
      const encryptExpiryMonth = selector(state, 'card.expiryMonth');
      const ias = selector(state, 'ias');
      const iobsp = selector(state, 'iobsp');

      return {
        auth: state.auth,
        encryptCardCvv,
        encryptCardNumber,
        encryptExpiryYear,
        encryptExpiryMonth,
        quote: state.quote,
        branding: state.branding,
        i18n: state.branding.i18n,
        isDrawerOpened: state.header.isDrawerOpened,
        ias,
        iobsp,
      };
    },
    (dispatch) => ({
      actions: {
        push: bindActionCreators(push, dispatch),
        quote: bindActionCreators({ ...quoteActions }, dispatch),
        branding: bindActionCreators({ ...brandingActions }, dispatch),
      },
    }),
  ),
  withRouter,
])(Quote);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/Quote/index.tsx